<template>
    <div>
        <section class="section section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-dark">
                <!-- Insert Image Here -->
            </div>
            <div class="container py-0">
                <div class="row row-grid align-items-center">
                    <div class="col-md-6 order-lg-2 ml-lg-auto">
                    </div>
                    <div class="col-lg-6 order-lg-1">
                        <div class="pl-0">
                            <h4 class="display-3 text-white">What We Teach</h4>
                            <p class="text-white">We adhere to <b>Baptist Faith and Message 2000</b>
                                <span class="subcaption"> (See more details <a :href="bmf2000Ref">here.</a>)</span>
                                and <b>Acts 29 Distinctives</b> <span class="subcaption"> (See more details <a
                                        :href="acts29Ref">here.</a>)</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="section section-shaped section-lg my-0">
            <div class="container">
                <div class="row justify-content-center mb-4">
                    <div class="col-lg-12">
                        <h2 class="display-3">Our Distinctives</h2>
                        <br />

                        <div class="distinctives">
                            <p class="display-4">Biblical Authority</p>
                            <p class="lead">
                                The Holy Bible was written by men divinely inspired and is God’s revelation of Himself
                                to man. It is a perfect treasure of divine instruction. It has God for its author,
                                salvation for its end, and truth, without any mixture of error, for its matter.
                                Therefore, all Scripture is totally true and trustworthy. It reveals the principles by
                                which God judges us, and therefore is, and will remain to the end of the world, the true
                                center of Christian union, and the supreme standard by which all human conduct, creeds,
                                and religious opinions should be tried. All Scripture is a testimony to Christ, who is
                                Himself the focus of divine revelation.
                            </p>
                            <p>
                                Exodus 24:4; Deuteronomy 4:1-2; 17:19; Joshua 8:34; Psalms 19:7-10; 119:11,89,105,140;
                                Isaiah 34:16; 40:8; Jeremiah 15:16; 36:1-32; Matthew 5:17-18; 22:29; Luke 21:33;
                                24:44-46; John 5:39; 16:13-15; 17:17; Acts 2:16ff.; 17:11; Romans 15:4; 16:25-26; 2
                                Timothy 3:15-17; Hebrews 1:1-2; 4:12; 1 Peter 1:25; 2 Peter 1:19-21.
                            </p>
                            <p class="see-more">
                                (See <a href="https://bfm.sbc.net/bfm2000/#i">BFM 2000 Article I</a>)
                            </p>
                        </div>

                        <div class="distinctives">
                            <p class="display-4">Gospel Centrality</p>
                            <p class="lead">
                                The gospel is the good news of what God has graciously accomplished for
                                sinners through the sinless life, sacrificial death, and bodily resurrection of his Son,
                                our Savior, Jesus Christ—namely our forgiveness from sin and complete justification
                                before God. This gospel is also the foundation for our confidence in the ultimate
                                triumph of God’s kingdom, and the consummation of his purpose for all creation in the
                                new heavens and new earth.
                            </p>
                            <p class="lead">
                                This gospel is centered in Christ, is the foundation for the life of the church, and is
                                our only hope for eternal life. This gospel is not proclaimed if Christ’s penal
                                substitutionary death and bodily resurrection are not central to our message.
                            </p>
                            <p class="lead">
                                This gospel is not only the means by which people are saved but also the truth and power
                                by which people are sanctified; it is the truth of the gospel that enables us to
                                genuinely and joyfully do what is pleasing to God and to grow in progressive conformity
                                to the image of Christ.
                            </p>
                            <p class="lead">
                                The salvation offered in this gospel message is received by grace alone, through faith
                                alone, in Christ alone; no ordinance, ritual, work, or any other activity on the part of
                                man is required in order to be saved.
                            </p>
                            <p>
                                Mark 1:1; Luke 24:46-47; John 3:16-18; Romans 1:16-17; 3:21-26, 5:1-11; 1 Corinthians
                                1:18-25; 2:2; 15:1-4; 2 Corinthians 4:1-6; 9:13; Galatians 1:6-9; Ephesians 1: 7-10;
                                Colossians 1: 19-20; 2 Timothy 1:8-14; 2 Peter 3: 11-13 Jude 3-4; Revelation 21:1-22:21
                            </p>
                            <p class="see-more">
                                (See <a href="https://www.acts29.com/about-us/distinctives/">Acts 29 Distinctive 1</a>)
                            </p>
                        </div>

                        <div class="distinctives">
                            <p class="display-4">God's Purpose of Grace</p>
                            <p class="lead">
                                Election is the gracious purpose of God, according to which He regenerates, justifies,
                                sanctifies, and glorifies sinners. It is consistent with the free agency of man, and
                                comprehends all the means in connection with the end. It is the glorious display of
                                God’s sovereign goodness, and is infinitely wise, holy, and unchangeable. It excludes
                                boasting and promotes humility.
                            </p>
                            <p class="lead">
                                All true believers endure to the end. Those whom God has accepted in Christ, and
                                sanctified by His Spirit, will never fall away from the state of grace, but shall
                                persevere to the end. Believers may fall into sin through neglect and temptation,
                                whereby they grieve the Spirit, impair their graces and comforts, and bring reproach on
                                the cause of Christ and temporal judgments on themselves; yet they shall be kept by the
                                power of God through faith unto salvation.
                            </p>
                            <p>
                                Genesis 12:1-3; Exodus 19:5-8; 1 Samuel 8:4-7,19-22; Isaiah 5:1-7; Jeremiah 31:31ff.;
                                Matthew 16:18-19; 21:28-45; 24:22,31; 25:34; Luke 1:68-79; 2:29-32; 19:41-44; 24:44-48;
                                John 1:12-14; 3:16; 5:24; 6:44-45,65; 10:27-29; 15:16; 17:6,12,17-18; Acts 20:32; Romans
                                5:9-10; 8:28-39; 10:12-15; 11:5-7,26-36; 1 Corinthians 1:1-2; 15:24-28; Ephesians
                                1:4-23; 2:1-10; 3:1-11; Colossians 1:12-14; 2 Thessalonians 2:13-14; 2 Timothy 1:12;
                                2:10,19; Hebrews 11:39–12:2; James 1:12; 1 Peter 1:2-5,13; 2:4-10; 1 John 1:7-9; 2:19;
                                3:2.
                            </p>
                            <p class="see-more">
                                (See <a href="https://bfm.sbc.net/bfm2000/#v">BFM 2000 Article V</a>)
                            </p>
                        </div>

                        <div class="distinctives">
                            <p class="display-4">Priesthood of Believers</p>
                            <p class="lead">Each believer is competent to relate to God through Jesus Christ.
                                Hence, baptism and church membership are only for the regenerate, those born again
                                through faith in Jesus Christ.</p>
                            <p class="lead">
                                It is the duty and privilege of every follower of Christ and of every church of the Lord
                                Jesus Christ to endeavor to make disciples of all nations. The new birth of man’s spirit
                                by God’s Holy Spirit means the birth of love for others. Missionary effort on the part
                                of all rests thus upon a spiritual necessity of the regenerate life, and is expressly
                                and repeatedly commanded in the teachings of Christ. The Lord Jesus Christ has commanded
                                the preaching of the gospel to all nations. It is the duty of every child of God to seek
                                constantly to win the lost to Christ by verbal witness undergirded by a Christian
                                lifestyle, and by other methods in harmony with the gospel of Christ.
                            </p>
                            <p>
                                Genesis 12:1-3; Exodus 19:5-6; Isaiah 6:1-8; Matthew 9:37-38; 10:5-15; 13:18-30, 37-43;
                                16:19; 22:9-10; 24:14; 28:18-20; Luke 10:1-18; 24:46-53; John 14:11-12; 15:7-8,16;
                                17:15; 20:21; Acts 1:8; 2; 8:26-40; 10:42-48; 13:2-3; Romans 10:13-15; Ephesians 3:1-11;
                                1 Thessalonians 1:8; 2 Timothy 4:5; Hebrews 2:1-3; 11:39-12:2; 1 Peter 2:4-10;
                                Revelation 22:17.
                            </p>
                            <p class="see-more">
                                (See <a href="https://bfm.sbc.net/bfm2000/#xi">BFM 2000 Article XI</a>)
                            </p>
                        </div>

                        <div class="distinctives">
                            <p class="display-4">Baptism and the Lord’s Supper</p>
                            <p class="lead">Christian baptism is the immersion of a believer in water in the name of the
                                Father, the Son, and the Holy Spirit. It is an act of obedience symbolizing the
                                believer’s faith in a crucified, buried, and risen Saviour, the believer’s death to sin,
                                the burial of the old life, and the resurrection to walk in newness of life in Christ
                                Jesus. It is a testimony to his faith in the final resurrection of the dead. Being a
                                church ordinance, it is prerequisite to the privileges of church membership and to the
                                Lord’s Supper.
                            </p>
                            <p class="lead">
                                The Lord’s Supper is a symbolic act of obedience whereby members of the church, through
                                partaking of the bread and the fruit of the vine, memorialize the death of the Redeemer
                                and anticipate His second coming.
                            </p>
                            <p>
                                Matthew 3:13-17; 26:26-30; 28:19-20; Mark 1:9-11; 14:22-26; Luke 3:21-22; 22:19-20; John
                                3:23; Acts 2:41-42; 8:35-39; 16:30-33; 20:7; Romans 6:3-5; 1 Corinthians 10:16,21;
                                11:23-29; Colossians 2:12.
                            </p>
                            <p class="see-more">
                                (See <a href="https://bfm.sbc.net/bfm2000/#vii">BFM 2000 Article VII</a>)
                            </p>
                        </div>

                        <div class="distinctives">
                            <p class="display-4">Autonomy of the Local Church</p>
                            <p class="lead">A New Testament church of the Lord Jesus Christ is an autonomous local
                                congregation of baptized believers, associated by covenant in the faith and fellowship
                                of the gospel; observing the two ordinances of Christ, governed by His laws, exercising
                                the gifts, rights, and privileges invested in them by His Word, and seeking to extend
                                the gospel to the ends of the earth. Each congregation operates under the Lordship of
                                Christ through democratic processes. In such a congregation each member is responsible
                                and accountable to Christ as Lord. Its two scriptural offices are that of
                                pastor/elder/overseer and deacon. While both men and women are gifted for service in the
                                church, the office of pastor/elder/overseer is limited to men as qualified by Scripture.
                            </p>
                            <p class="lead">
                                The New Testament speaks also of the church as the Body of Christ which includes all of
                                the redeemed of all the ages, believers from every tribe, and tongue, and people, and
                                nation.
                            </p>
                            <p>
                                Matthew 16:15-19; 18:15-20; Acts 2:41-42,47; 5:11-14; 6:3-6; 13:1-3; 14:23,27; 15:1-30;
                                16:5; 20:28; Romans 1:7; 1 Corinthians 1:2; 3:16; 5:4-5; 7:17; 9:13-14; 12; Ephesians
                                1:22-23; 2:19-22; 3:8-11,21; 5:22-32; Philippians 1:1; Colossians 1:18; 1 Timothy
                                2:9-14; 3:1-15; 4:14; Hebrews 11:39-40; 1 Peter 5:1-4; Revelation 2-3; 21:2-3.
                            </p>
                            <p>
                                *Note: This article was amended June 14, 2023, by action of the 2023 Southern Baptist
                                Convention*
                            </p>
                            <p class="see-more">
                                (See <a href="https://bfm.sbc.net/bfm2000/#vi">BFM 2000 Article VI</a>)
                            </p>
                        </div>

                        <div class="distinctives">
                            <p class="display-4">Religious Liberty</p>
                            <p class="lead">God alone is Lord of the conscience, and He has left it free from the
                                doctrines and commandments of men which are contrary to His Word or not contained in it.
                                Church and state should be separate. The state owes to every church protection and full
                                freedom in the pursuit of its spiritual ends. In providing for such freedom no
                                ecclesiastical group or denomination should be favored by the state more than others.
                                Civil government being ordained of God, it is the duty of Christians to render loyal
                                obedience thereto in all things not contrary to the revealed will of God. The church
                                should not resort to the civil power to carry on its work. The gospel of Christ
                                contemplates spiritual means alone for the pursuit of its ends. The state has no right
                                to impose penalties for religious opinions of any kind. The state has no right to impose
                                taxes for the support of any form of religion. A free church in a free state is the
                                Christian ideal, and this implies the right of free and unhindered access to God on the
                                part of all men, and the right to form and propagate opinions in the sphere of religion
                                without interference by the civil power.
                            </p>
                            <p>
                                Genesis 1:27; 2:7; Matthew 6:6-7,24; 16:26; 22:21; John 8:36; Acts 4:19-20; Romans
                                6:1-2; 13:1-7; Galatians 5:1,13; Philippians 3:20; 1 Timothy 2:1-2; James 4:12; 1 Peter
                                2:12-17; 3:11-17; 4:12-19.
                            </p>
                            <p class="see-more">
                                (See <a href="https://bfm.sbc.net/bfm2000/#xvii">BFM 2000 Article XVII</a>)
                            </p>
                        </div>

                        <div class="distinctives">
                            <p class="display-4">Church Planting Churches</p>

                            <p class="lead">
                                We embrace a missionary understanding of the local church and its role as the primary
                                means by which God chooses to establish his kingdom on earth.
                            </p>
                            <p class="lead">The church has a clear biblical mandate to look beyond its own community to
                                the neighborhood, the nation, and the world as a whole; thus, mission is not an optional
                                program in the church but an essential element in the identity of the church.

                                We are called to make Christ known through the gospel and, by the power of the Holy
                                Spirit, to bring his lordship to bear on every dimension of life.

                                The primary way we fulfill this mission is through the planting of churches that plant
                                churches and the training of their leaders. Our aim is that Jesus Christ would be more
                                fully formed in each person through the ministry of those churches God enables us to
                                plant around the world.

                                We also believe we are responsible neither to retreat from our culture nor to conform to
                                it, but with humility, through the Spirit and the truth of the gospel, to engage it
                                boldly as we seek its transformation and submission to the lordship of Christ.
                            </p>
                            <p>
                                Isaiah 52:7; Matthew 10:5-25; 28:18-20; Luke 4:18-19; 24:46-47; Acts 28:31; Romans
                                10:14-15; 2 Corinthians 10:4-5; Galatians 2:10; Ephesians 3:10; 4:11-16; 2 Timothy
                                4:1-5; Hebrews 10:23-25; 1 Peter 2:4-5, 9-10
                            </p>
                            <p class="see-more">
                                (See <a href="https://www.acts29.com/about-us/distinctives/">Acts 29 Distinctive 5</a>)
                            </p>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "what-we-teach",
    components: {},
    data() {
        return {
            bmf2000Ref: "https://bfm.sbc.net/bfm2000/",
            acts29Ref: "https://www.acts29.com/about-us/distinctives/"
        }
    }
};
</script>

<style scoped>
.subcaption {
    font-style: italic;
    font-size: small;
}

.distinctives {
    margin-top: 20px;
    margin-bottom: 60px;
}

.see-more {
    font-style: italic;
}
</style>
